import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LodashService } from './services/lodash.service';

import { SettingsService } from '../shared/services/settings.service';
import { SocketIoConfig } from 'ngx-socket-io';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { Ng7BootstrapBreadcrumbModule } from 'ng7-bootstrap-breadcrumb';
import { EfoXlsService } from './services/efo-xls.service';
import { EfoMapService } from './services/efo-map.service';
import { Daterangepicker } from 'ng2-daterangepicker';

import { Inject, Injectable, InjectionToken } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HTTP_INTERCEPTORS,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule } from 'angular-datatables';

export const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
  constructor(@Inject(DEFAULT_TIMEOUT) protected defaultTimeout: number) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const timeoutValue = req.headers.get('timeout') || this.defaultTimeout;
    const timeoutValueNumeric = Number(timeoutValue);
    console.log('intercepter', timeoutValueNumeric);
    return next.handle(req).pipe(timeout(timeoutValueNumeric));
  }
}

const config: SocketIoConfig = {
  url: 'http://192.168.240.48:3000',
  options: {},
};

@NgModule({
  exports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    PerfectScrollbarModule,
    NgbModule,
    NgxDatatableModule,
    DataTablesModule,
    Ng7BootstrapBreadcrumbModule,
    Daterangepicker,
    NgSelectModule,
  ],
  imports: [
    RouterModule,
    CommonModule,
    PerfectScrollbarModule,
    NgbModule,
    //Importing RestangularModule and making default configs for restanglar
    NgxDatatableModule,
    Ng7BootstrapBreadcrumbModule,
    Daterangepicker,
    NgSelectModule,
    DataTablesModule,
  ],
  declarations: [],
  providers: [
    LodashService,
    EfoXlsService,
    EfoMapService,
    [{ provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptor, multi: true }],
    [{ provide: DEFAULT_TIMEOUT, useValue: 30000 }],
  ],
})
export class SharedModule {}
